import { jsx as _jsx } from "react/jsx-runtime";
import { hintCss } from "@devowl-wp/web-cookie-banner";
import { forwardRef } from "react";
/**
 * This is a very basic `hint.css` implementation for a tooltip.
 *
 * @see https://kushagra.dev/lab/hint/
 */ const Tooltip = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { children, title, position, color, size, always, rounded, noAnimate, bounce, className, ...rest } = param;
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        ...rest,
        ...hintCss({
            title,
            always,
            position,
            color,
            size,
            rounded,
            noAnimate,
            bounce,
            className
        }),
        children: children
    });
});
export { Tooltip };
